import { Component, OnInit } from '@angular/core';
import { AnalysisService } from '../../../services/analysis.service';
import { PowerPlant } from '../../../common/components/solar-calculation-result/model/power-plant';
import { finalize } from 'rxjs';
import { FormControl } from '@angular/forms';
import { UnsubscribeOnDestroyAdapter } from '../../../common/adapters/unsubscibe-on-destroy.adapter';
import { popInOut } from '../../../common/animations';
import { PageTitleService } from '../../../services/page-title.service';

@Component({
  selector: 'psc-saved-power-plants',
  templateUrl: './saved-power-plants.component.html',
  animations: [popInOut],
})
export class SavedPowerPlantsComponent extends UnsubscribeOnDestroyAdapter implements OnInit {
  shownPowerPlants: PowerPlant[];
  allPowerPlants: PowerPlant[];

  search = new FormControl('');
  loading: boolean = false;

  constructor(
    private analysisService: AnalysisService,
    private pageTitleService: PageTitleService,
  ) {
    super();
    /**
     * t(title.user.saved-plants)
     */
    this.pageTitleService.setTitle('title.user.saved-plants');
  }

  ngOnInit() {
    this.getPowerPlants();
    this.subs.sink = this.search.valueChanges.subscribe((searchText) => {
      this.searchPowerPlants(searchText);
    });
  }

  getPowerPlants() {
    this.loading = true;
    this.analysisService.getSavedPowerPlants().pipe(
      finalize(() => {
        this.loading = false;
      }),
    ).subscribe((powerPlants) => {
      this.allPowerPlants = powerPlants;
      this.searchPowerPlants(this.search.value);
    });
  }

  private searchPowerPlants(searchText: string | null) {
    if (!searchText) {
      this.shownPowerPlants = this.allPowerPlants;
      return;
    }
    this.shownPowerPlants = this.allPowerPlants.filter((plant) => plant.projectName.toLowerCase().search(searchText.toLowerCase()) > -1);
  }
}
